import { CheckIcon, Group, Stack, Text } from "@mantine/core";
import type { ComboboxItem } from "@mantine/core";

type SegmentComboboxItem = ComboboxItem & { description?: string | null };

/**
 * Shared `renderOption` for segment Select/MultiSelect dropdowns — shows the
 * segment label plus its one-line description underneath so users can tell
 * broad segments (Tech, BPO Operations, ...) apart at a glance.
 */
export function renderSegmentOption({
  option,
  checked,
}: {
  option: ComboboxItem;
  checked?: boolean;
}) {
  const opt = option as SegmentComboboxItem;
  return (
    <Group flex="1" gap="xs" wrap="nowrap" align="flex-start" py="var(--axio-unit-2)">
      {checked ? <CheckIcon size="var(--axio-unit-12)" style={{ marginTop: "var(--axio-unit-4)" }} /> : null}
      <Stack gap="var(--axio-unit-0)">
        <Text size="sm" fw="var(--axio-font-weight-medium)">
          {opt.label}
        </Text>
        {opt.description && (
          <Text size="xs" c="dimmed">
            {opt.description}
          </Text>
        )}
      </Stack>
    </Group>
  );
}
